export enum CommunicationActionType {
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY"
}
